import { EnergyRating } from "@JohnLewisPartnership/jl-design-system/dist/components/energy-rating/EnergyRating";
import styles from "./EnergyLabelCTA.module.scss";
import { ChevronRightOutlined as ChevronRight } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/ChevronRightOutlined";
import classnames from "classnames/bind";

const cx = classnames.bind(styles);

export type EnergyLabelCTAProps = {
  handleClick?: () => void;
  isLegacy: boolean;
  rating: string;
  dataComponent?: string;
};

export const EnergyLabelCTA = ({
  handleClick,
  isLegacy,
  rating,
}: EnergyLabelCTAProps) => {
  return (
    <button
      className={cx("energyLabelItem", "premiumStyle")}
      onClick={handleClick}
    >
      <EnergyRating
        rating={isLegacy ? undefined : rating}
        ratingLegacy={isLegacy ? rating : undefined}
        className={styles.energyLabelIcon}
      />
      <span className={cx("energyRatingText")}>Energy rating</span>
      <ChevronRight size="medium" />
    </button>
  );
};
